/**
 * Groups an array of glossary terms by their starting letter.
 *
 * @param glossary - The array of glossary terms to group.
 * @returns An object where each key is a letter and the value is an array of terms starting with that letter.
 */

import { GlossaryTerm } from '../types/guide.types'

export function groupGlossaryByLetter(
  glossary: GlossaryTerm[] = [],
): Record<string, GlossaryTerm[]> {
  return glossary.reduce<Record<string, GlossaryTerm[]>>((acc, item) => {
    const letter = item.letter
    if (!acc[letter]) {
      acc[letter] = []
    }
    acc[letter].push(item)
    return acc
  }, {})
}

export const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))
